import { useEffect, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import "../login-page.css";

const STAR_COUNT = 42;

export function LoginPage() {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      if (localStorage.getItem("eo_token")) navigate("/today", { replace: true });
    } catch {
      /* ignore */
    }
  }, [navigate]);

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    setBusy(true);
    setError("");
    try {
      const res = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: String(form.get("username") ?? "").trim(),
          password: String(form.get("password") ?? "")
        })
      });
      const payload = (await res.json().catch(() => ({}))) as { data?: { token?: string }; error?: { message?: string } };
      if (!res.ok || !payload.data?.token) {
        setError(payload.error?.message ?? "密码错误，请重试");
        setBusy(false);
        return;
      }
      try {
        localStorage.setItem("eo_token", payload.data.token);
      } catch {
        /* ignore */
      }
      navigate("/today", { replace: true });
    } catch {
      setError("连接服务器失败");
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-scene">
        <div className="login-stars">
          {Array.from({ length: STAR_COUNT }, (_, i) => (
            <i
              key={i}
              className="login-star"
              style={{
                left: `${(i * 37) % 96}%`,
                top: `${(i * 53) % 58}%`,
                animationDelay: `${(i % 5) * 0.4}s`
              }}
            />
          ))}
        </div>
        <div className="login-cloud" style={{ top: "12%", animationDelay: "0s" }} />
        <div className="login-cloud login-cloud--small" style={{ top: "26%", animationDelay: "-14s" }} />
        <div className="login-tree" style={{ left: "6%", transform: "scale(1.2)" }}>
          <div className="login-leaf" />
          <div className="login-trunk" />
        </div>
        <div className="login-tree" style={{ right: "8%", transform: "scale(0.9)" }}>
          <div className="login-leaf" />
          <div className="login-trunk" />
        </div>
        <div className="login-ground" />
      </div>

      <div className="login-panel-wrap">
        <form className="login-panel" onSubmit={(event) => void submit(event)} autoComplete="off">
          <div className="login-logo">
            <div className="login-title">EARTH ONLINE</div>
            <div className="login-sub">— 地 球 在 线 · 私 人 成 长 世 界 —</div>
            <span className="login-version">SINGLE PLAYER · v3.0</span>
          </div>
          <div className="login-field">
            <label htmlFor="username">玩家 ID</label>
            <input id="username" name="username" placeholder="输入用户名" required />
          </div>
          <div className="login-field">
            <label htmlFor="password">密 码</label>
            <input id="password" name="password" type="password" placeholder="输入密码" required />
          </div>
          <button className="login-btn" type="submit" disabled={busy}>
            {busy ? "载 入 中 …" : "▶ 开 始 游 戏"}
          </button>
          {error && <div className="login-error">{error}</div>}
        </form>
        <div className="login-knight-stage" aria-hidden="true">
          <img src="/earth-online-knight-v3.png" alt="" draggable={false} />
          <span>DIGITAL SELF · ONLINE</span>
        </div>
      </div>

      <div className="login-footer">EARTH ONLINE · 只属于你的世界</div>
    </div>
  );
}
